<artemis-breadcrumbs [breadcrumbs]="breadcrumbs | async"></artemis-breadcrumbs>
<artemis-customer-overview-card></artemis-customer-overview-card>
<div class="customer-relationship-map-card" [ngClass]="{'customer-relationship-map-card_maximized': maximized}">
  <div ubi-curve-header class="customer-relationship-map-card__header">
    <span class="customer-relationship-map-card__header-text">RELATIONSHIP MAP</span>
  </div>
  <artemis-popover>
    Relationship Map shows the relevant linkages between Corporate Customer and its respective Customer Related Persons (CRPs). Hovering over the arrow will display relationship and role(s). Clicking on CRP node will display other relationships that CRP has with other Corporate Customer that are already input into Artemis, if any.
  </artemis-popover>
  <div class="customer-relationship-map-card__content-container">
    <artemis-loading-spinner *ngIf="loading"></artemis-loading-spinner>
    <div [ngStyle]="{'visibility': loading ? 'hidden':'visible'}" id="relationship-map" class="relationship-map">

    </div>
    <div *ngIf="!maximized" class="vis-button vis-maximize" (click)="toggleFullScreen()"></div>
    <div *ngIf="maximized" class="vis-button vis-exit" (click)="toggleFullScreen()"></div>
  </div>
</div>
